import { usePack } from "./usePack";
import { usePackAssets } from "./usePackAssets";
import { useLoggedinUser } from "./useLoggedinUser";
import { runSyncPack } from "domains/pack/api";
import { useE2EEContext } from "lib/e2ee";
import { needOldPassword } from "lib/utils";

export const useRunSync = (packId: string) => {
  const { data: pack, mutate: mutatePack } = usePack(packId);
  const { data: assets, mutate: mutateAssets } = usePackAssets(pack);
  const { data: user } = useLoggedinUser();
  const { needNonce } = useE2EEContext();

  return {
    sync: async () => {
      if (needOldPassword(pack, user) || (pack?.is_encrypted && needNonce)) return;

      return await runSyncPack(pack, mutatePack, assets, mutateAssets, user?.id)
    }
  }
}


